import React from "react"
import PropTypes from "prop-types"

// import UserPreview from './UserPreview';
// import ConnectPreview from './ConnectPreview';

class CommunityWatchDashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      time: {},
      seconds: 120,
      newestUsers: [],
      recentlyUpdatedUsers: [],
      lastSeenUsers: [],
      lastConnectRequests: []
    };
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
    this.refetchData = this.refetchData.bind(this)

    this.renderNewestUsers = this.renderNewestUsers.bind(this)
    this.renderRecentlyUpdatedUsers = this.renderRecentlyUpdatedUsers.bind(this)
    this.renderLastSeenUsers = this.renderLastSeenUsers.bind(this)
  }

  secondsToTime(secs){
    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      "m": minutes,
      "s": seconds
    };
    return obj;
  }

  componentDidMount() {
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
  }

  refetchData() {
    clearInterval(this.timer);
    this.setState({
      newestUsers: [],
      recentlyUpdatedUsers: [],
      lastSeenUsers: [],
      lastConnectRequests: []
    })
    $.ajax({
      url: `../ajax_community_watch`,
      dataType: 'JSON',
      type: 'POST',
      data: {},
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          newestUsers: JSON.parse(data.data.newest_users),
          recentlyUpdatedUsers: JSON.parse(data.data.recently_updated_users),
          lastSeenUsers: JSON.parse(data.data.last_seen_users),
          lastConnectRequests: JSON.parse(data.data.last_connect_requests)
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });

    this.setState({
      time: {},
      seconds: 120
    }, () => this.startTimer())
  }

  startTimer() {
      this.timer = setInterval(this.countDown, 1000);
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds == 0) {
      clearInterval(this.timer);
    }
  }

  renderNewestUsers() {
    return this.state.newestUsers.map((user, i) => {
      return (<UserPreview
        user={user}
        key={i}
        missingImg={this.props.missingImg}
         />)
    })
  }

  renderRecentlyUpdatedUsers() {
    return this.state.recentlyUpdatedUsers.map((user, i) => {
      return (<UserPreview
        user={user}
        key={i}
        missingImg={this.props.missingImg}
         />)
    })
  }

  renderLastSeenUsers() {
    return this.state.lastSeenUsers.map((user, i) => {
      return (<UserPreview
        user={user}
        key={i}
        missingImg={this.props.missingImg}
         />)
    })
  }

  renderConnects() {
    return this.state.lastConnectRequests.map((connect, i) => {
      return (<ConnectPreview
        connect={connect}
        key={i}
         />)
    })
  }


  render() {
    return <h1>Hey</h1>
    return(
      <div>
        <h1>Community Watch</h1>
        <div>
          <button onClick={this.refetchData} className="small_button_primary">Start</button>
          <h3>m: {this.state.time.m} s: {this.state.time.s}</h3>
        </div>
        <div>
          <h3 style={{textAlign: 'center', paddingTop: 15}}>20 Newest Members</h3>
            {this.renderNewestUsers()}
          <h3 style={{textAlign: 'center', paddingTop: 15}}>10 Most recently updated Members</h3>
            {this.renderRecentlyUpdatedUsers()}
          <h3 style={{textAlign: 'center', paddingTop: 15}}>10 Most recently seen Members</h3>
            {this.renderLastSeenUsers()}
          <h3 style={{textAlign: 'center', paddingTop: 15}}>20 recent Connect requests</h3>
            {this.renderConnects()}
        </div>
      </div>
    )
  }

}

export default CommunityWatchDashboard;
